/**
 * Joshua Alele-Beals
 * joshbeals22@gmail.com
 * github.com/joshBeals
 */

import { Trash, PencilSquare, Files } from "react-bootstrap-icons";
import { Alert, Button, Table, Row, Col, Form, Card } from "react-bootstrap";
import ScenarioForm from "../forms/ScenarioForm";
import { useAppState } from "../store/AppStateContext";
import ScenarioResult from "./ScenarioResult";
import { useState } from "react";

function ScenarioMain({ setShouldRun }) {
    const [selected, setSelected] = useState([]);
    const [editingIndex, setEditingIndex] = useState(null);

    const { scenarios, deleteScenario, deleteScenarios, duplicateScenario, showResult, setShowResult, interpretation, setInterpretation } = useAppState();

    const handleInterpretationChange = (e) => {
        setInterpretation(e.target.value);
    }

    const toggleSelect = (index) => {
        setSelected(prev =>
            prev.includes(index)
                ? prev.filter(i => i !== index)
                : [...prev, index]
        );
    };
    
    const deleteSelected = () => {
        if (selected.length === 0) {
            alert("No scenarios selected");
            return;
        }
    
        if (!window.confirm("Delete selected scenarios?")) return;
    
        deleteScenarios(selected);
        setSelected([]);
    }; 

    const startEdit = (index) => {
        setEditingIndex(index);
    };    

    const checkResult = () => {
        if (scenarios.length === 0) {
            alert("You haven't setup any scenario yet!");
            return;
        }
        
        if (interpretation == '') {
            alert("Please Select Interpretation!");
            return;
        }

        setShouldRun(true);
        setShowResult(true);
    }

    const goBack = () => {
        setShowResult(false);
        // setInterpretation('');
        setShouldRun(false);
    }

    return (
        <div>
            <ScenarioForm
                editingIndex={editingIndex}
                setEditingIndex={setEditingIndex} 
            />
            {scenarios?.length > 0 ? (

                <Card className="my-3">
                <Card.Header className="d-flex justify-content-between align-items-center">
                    Conviction History
                    {selected.length > 0 && (
                        <Button
                            variant="danger"
                            className="btn-sm mt-2"
                            onClick={deleteSelected}
                        >
                            Delete Selected ({selected.length})
                        </Button>
                    )}
                </Card.Header>
                <Card.Body className="">
                    <Table
                        striped
                        bordered
                        responsive
                        className="mt-3"
                        style={{ borderRadius: "20px" }}
                    >
                        <thead>
                            <tr>
                                <th>
                                    <Form.Check
                                        type="checkbox"
                                        onChange={(e) =>
                                            setSelected(
                                                e.target.checked ? scenarios.map((_, i) => i) : []
                                            )
                                        }
                                    />
                                </th>
                                <th>Conviction Type</th>
                                <th>Year</th>
                                <th>Assaultive</th>
                                <th>TenYearFelony</th>
                                <th>OWI</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {scenarios?.map((scenario, index) => (
                                <tr key={index}>
                                    <td>
                                        <Form.Check
                                            type="checkbox"
                                            checked={selected.includes(index)}
                                            onChange={() => toggleSelect(index)}
                                        />
                                    </td>
                                    <td>{scenario?.type}</td>
                                    <td>{scenario?.year}</td>
                                    <td>{scenario?.assaultive ? 'Yes' : 'No'}</td>
                                    <td>{scenario?.tenner ? 'Yes' : 'No'}</td>
                                    <td>{scenario?.owi ? 'Yes' : 'No'}</td>
                                    <td>
                                        <PencilSquare
                                            className="text-primary"
                                            style={{ cursor: "pointer", marginRight: "5px" }}
                                            onClick={() => startEdit(index)}
                                        />
                                        <Files
                                            title="Duplicate scenario"
                                            className="text-secondary"
                                            style={{ cursor: "pointer", marginRight: "5px" }}
                                            onClick={() => duplicateScenario(index)}
                                        />
                                        <Trash
                                            onClick={() => deleteScenario(index)}
                                            className="text-danger"
                                            style={{ cursor: "pointer" }}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <div className="">
                        {showResult ? (
                            <Button variant="primary" onClick={goBack}>
                                Go Back
                            </Button>
                        ):(
                            <Button variant="primary" onClick={checkResult}>
                                Check Result
                            </Button>
                        )}
                    </div>
                </Card.Body>
            </Card>
            ):(
                <div className="mt-3"></div>
            )}
    
            {/* {scenarios?.length > 0 && (
                <Card>
                    <Card.Body>
                        <Row className="mb-2">
                            <Col xs={12}>
                                <Form.Label>Choose Interpretation</Form.Label>
                                <Form.Select value={interpretation} onChange={handleInterpretationChange} disabled={interpretation !== ""}>
                                    <option>Select Interpretation</option>
                                    <option key="forward" value="forward">Forward Waiting</option>
                                    <option key="backward" value="backward">Backward Waiting</option>
                                </Form.Select>
                            </Col>
                        </Row>
                        {showResult ? (
                            <Button variant="primary" onClick={goBack}>
                            Go Back
                            </Button>
                        ):(
                            <Button variant="primary" onClick={checkResult}>
                            Check Result
                            </Button>
                        )}
                    </Card.Body>
                </Card>
            )} */}
        </div>
    );
};

export default ScenarioMain;